import React from 'react';

interface GameHelpIconProps {
  size?: string | number;
}

export const GameHelpIcon: React.FC<GameHelpIconProps> = ({ size = 33 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 33 33"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0219 6.89554C16.774 6.89554 16.0757 8.066 16.1054 8.97465C16.1054 9.9295 16.6849 10.5301 17.5614 10.5301C18.6608 10.5301 19.4779 9.57528 19.4779 8.51263C19.4779 7.65018 19.0025 6.89554 18.0219 6.89554ZM18.4526 22.3886C17.7246 23.0508 16.8926 23.6515 16.5955 23.6515C16.3875 23.6515 16.3132 23.3589 16.5361 22.5734L18.2743 15.2888C18.6606 13.7026 18.5714 12.6091 17.784 12.6091C16.8629 12.6091 14.8573 13.7488 13.03 15.5661L13.4608 16.4285C14.1888 15.7971 15.0059 15.258 15.2584 15.258C15.4367 15.2888 15.4367 15.5661 15.2881 16.2283L13.6688 23.2356C13.0597 25.6998 13.6391 26.2388 14.3373 26.2388C15.2881 26.2388 17.4126 24.9759 18.9428 23.2048L18.4526 22.3886ZM1.3288 16.5672C1.3288 24.8102 8.01111 31.4925 16.2542 31.4925C24.4972 31.4925 31.1795 24.8102 31.1795 16.5672C31.1795 8.3241 24.4972 1.64178 16.2542 1.64178C8.01111 1.64178 1.3288 8.3241 1.3288 16.5672ZM16.2542 0.447754C7.35167 0.447754 0.134766 7.66466 0.134766 16.5672C0.134766 25.4697 7.35167 32.6866 16.2542 32.6866C25.1567 32.6866 32.3736 25.4697 32.3736 16.5672C32.3736 7.66466 25.1567 0.447754 16.2542 0.447754Z"
        fill="white"
      />
    </svg>
  );
};
